import type { PageAdSize, PageAdType } from '@/modules/adv/types'

export const bannersConfig: Record<
    PageAdType,
    {
        sizes: PageAdSize[]
        placeholderHeight?: number
        refreshInterval?: number
    }
> = {
    sidebar: {
        sizes: [[300, 300], 'fluid'],
        placeholderHeight: 300,
        refreshInterval: 35,
    },
    sidebar_bottom: {
        sizes: [[300, 300], [300, 600], [120, 600], [160, 600], [300, 250], 'fluid'],
        refreshInterval: 35,
    },
    sidebar_fullscreen: {
        sizes: [[300, 600], [160, 600], [120, 600], 'fluid'],
        placeholderHeight: 600,
        refreshInterval: 35,
    },
    sidebar_bottom_fullscreen: {
        sizes: [[300, 300], [300, 250], 'fluid'],
        refreshInterval: 35,
    },
    leaderboard: {
        sizes: [[728, 90], [950, 90], [960, 90], [970, 90], [980, 90], 'fluid'],
        placeholderHeight: 90,
        refreshInterval: 35,
    },
    leaderboard_rest: {
        sizes: [[728, 90], [950, 90], [960, 90], [970, 90], [980, 90], 'fluid'],
        placeholderHeight: 90,
        refreshInterval: 35,
    },
    sticky_mobile_non_game_page: {
        sizes: [[320, 100], [300, 50], [320, 50], 'fluid'],
    },
    sticky_mobile: {
        sizes: [[300, 50], [320, 50], 'fluid'],
    },
    sticky_tablet: {
        sizes: [[728, 90], 'fluid'],
    },
    sticky_desktop: {
        sizes: [[970, 90], [960, 90], [950, 90], [980, 90], [728, 90], 'fluid'],
    },
    widget_sidebar: {
        sizes: [[120, 600], [300, 300], [300, 600], [160, 600], [300, 250], 'fluid'],
        refreshInterval: 35,
    },
    widget_sidebar_bottom: {
        sizes: [[300, 250], 'fluid'],
    },
    widget_horizontal: {
        sizes: [[728, 90], 'fluid'],
        refreshInterval: 35,
    },
    widget_horizontal_2: {
        sizes: [[728, 90], 'fluid'],
        refreshInterval: 35,
    },
    widget_sticky_mobile: {
        sizes: [[300, 50], [320, 50], 'fluid'],
    },
    widget_sticky_tablet: {
        sizes: [[728, 90], 'fluid'],
    },
    universal_banner_1: {
        sizes: [
            [960, 90],
            [300, 600],
            [970, 90],
            [300, 250],
            [336, 280],
            [320, 100],
            [950, 90],
            [320, 480],
            [300, 50],
            [480, 320],
            [300, 300],
            [728, 90],
            [120, 600],
            [320, 50],
            [160, 600],
            [300, 100],
            [980, 90],
        ],
        refreshInterval: 35,
    },
    universal_banner_short_1: {
        sizes: [
            [300, 250],
            [320, 100],
            [320, 50],
            [300, 100],
            [300, 50],
            [300, 300],
            [120, 600],
            [160, 600],
        ],
    },
    universal_banner_2: {
        sizes: [
            [960, 90],
            [300, 600],
            [970, 90],
            [300, 250],
            [336, 280],
            [320, 100],
            [950, 90],
            [320, 480],
            [300, 50],
            [480, 320],
            [300, 300],
            [728, 90],
            [120, 600],
            [320, 50],
            [160, 600],
            [300, 100],
            [980, 90],
        ],
        refreshInterval: 35,
    },
    // partner ads sdk formats, here just for type safety
    vertical_1: {
        sizes: [],
    },
    vertical_2: {
        sizes: [],
    },
    vertical_3: {
        sizes: [],
    },
    horizontal_1: {
        sizes: [],
    },
}
